import axios  from 'axios';
import md5 from "./md5.js";
const etcApi = {
    $request : axios.create({
        timeout: 50000,
        headers: {
            "Content-Type": "application/json", // 请求体中的数据会以json字符串的形式发送到后端
        }
    }),

    request(method,route,data, config = {}){
        return new Promise((resolve, reject) => {
			if( !method ){
				return reject('未设置请求方式');
			}else if( !route ){
				return reject('未设置请求路由');
			}
			
			let header = {
				'Content-Type':'application/json;charset=UTF-8',
				'ngrok-skip-browser-warning': 'true',
			};
			
			// 合并自定义配置
			if (config.headers) {
				header = { ...header, ...config.headers };
			}
			
			let options = {
				url     : $config.etcApihost + '/' + route,
				method  : method,
				headers : header,
				...config // 添加其他配置，如 responseType
			};
			
			if( method.toLowerCase() == 'get' ){
				// 处理 GET 请求参数
				const params = new URLSearchParams();
				if (data && typeof data === 'object') {
					Object.keys(data).forEach(key => {
						if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
							params.append(key, data[key]);
						}
					});
				}
				const queryString = params.toString();
				if (queryString) {
					options.url += '?' + queryString;
				}
			}else{
				options = Object.assign(options,{data:data});
			}
			
            etcApi.$request.request(options).then(res=>{
                if( res.status === 200 ){
                    res.data.code==0?resolve(res.data):reject(res.data);
                }else{
                    reject(res.data);
                }
                resolve(res)
            }).catch(err=>{
				if(err == 'Error: Request failed with status code 401'){
					reject('无权限')
				}
                reject(err)
            })
        });
    },

    get(route,data, config = {}){
        return etcApi.request('get',route,data, config);
    },
    
    post(route,data, config = {}){
        return etcApi.request('post',route,data, config);
    },
    
    download(route) {
        window.open($config.etcApihost + '/' + route);
    }
}
export default etcApi;